import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { ButtonWrapper } from 'cstar-react-primitives/lib/redux-form/buttons/ButtonWrapper';
import { ButtonLayoutWrapper } from 'cstar-react-primitives/lib/redux-form/buttons/ButtonLayoutWrapper';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getSubTotal } from '../item/itemSelectors';
import { getCreditCardValidationData, getMasterpassCheckoutId } from '../brand/brandSelectors';
import { getIntlCurrencyCode } from '../intl/intlSelectors';

import { MASTERPASS_CART_ID } from './masterpassSerializers';
import masterpassMessages from './masterpassMessages';
import { getMasterpassLoaded } from './masterpassModule';
import { getMasterpassCreditCardKeys, checkoutWithMasterpass } from './masterpass';


export const MasterpassButton = ({
    intl,
    total,
    currency,
    masterpassLoaded = false,
    checkoutId,
    allowedCreditCardData,
    isDisabled,
    labelId,
    children,
    handleSubmit
}) => {
    const directToMasterpass = () => {
        if (!isDisabled) {
            const allowedCardTypes = getMasterpassCreditCardKeys(allowedCreditCardData);
            const requestData = {
                checkoutId,
                allowedCardTypes,
                amount: `${total}`,
                currency,
                suppressShippingAddress: true, 
                cartId: MASTERPASS_CART_ID
            };
            checkoutWithMasterpass(requestData);
        }
    };

    const btnProps = {
        ariaLabel: intl.formatMessage(masterpassMessages.payWithMasterpass),
        btnType: 'button',
        cssClass: 'masterpass-btn',
        cashbotName: 'pay-with-masterpass',
        onClick: handleSubmit(directToMasterpass)
    };

    
    if (labelId) {
        btnProps.atts = {
            id: 'masterpass-button',
            'aria-labelledby': `${labelId} masterpass-button`
        };
    }

    if (!masterpassLoaded) {
        return null;
    }

    return (
        <ButtonLayoutWrapper>
            {children}
            <ButtonWrapper {...btnProps}>
                <FormattedMessage {...masterpassMessages.payWithMasterpass} />
            </ButtonWrapper>
        </ButtonLayoutWrapper>
    );
};

MasterpassButton.defaultProps = {
    masterpassLoaded: false,
    isDisabled: false,
    labelId: '',
    children: null
};

MasterpassButton.propTypes = {
    intl: intlShape.isRequired,
    total: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    checkoutId: PropTypes.string.isRequired,
    allowedCreditCardData: PropTypes.object.isRequired,
    masterpassLoaded: PropTypes.bool,
    isDisabled: PropTypes.bool,
    labelId: PropTypes.string,
    children: PropTypes.node,
    handleSubmit: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    total: parseFloat(getSubTotal(state).toFixed(2)),
    currency: getIntlCurrencyCode(state),
    masterpassLoaded: getMasterpassLoaded(state),
    checkoutId: getMasterpassCheckoutId(state),
    allowedCreditCardData: getCreditCardValidationData(state)
});

export default connect(mapStateToProps)(injectIntl(MasterpassButton));
